
import Vue from 'vue'
import dayjs from "dayjs";
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn')
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)


Vue.filter('relativeTime',value=>{
    return dayjs().to(dayjs(value))
})
Vue.filter('formatTime',value=>{
        // console.log(dayjs(value)
    return dayjs(value).format('YYYY.MM.DD HH:mm')
})
Vue.filter('nameencry',value=>{
    // if(!value){
    //     return
    // }
    // if(value.length==2){
    //     value=value.substring(0,1)+'*' //截取name 字符串截取第一个字符，
    // }else if(value.length==3){
    //     value=value.substring(0,1)+"**"//截取第一个和第三个字符
    //     // value=value.substring(0,1)+"*"+value.substring(2,3)//截取第一个和第三个字符
    // }else if(value.length>3){
    //     value=value.substring(0,1)+"***"+''+value.substring(3,value.length)//截取第一个和大于第4个字符
    // }
    return value
})
Vue.filter('sumFormat',value =>{
    return  Math.round(value/20)
})
